import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const downloadBank = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/bank",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadBankList = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/bankList",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadContact = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/contact",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadContactList = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/contactList",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadAddress = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/address",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadAddressList = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/addressList",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadTaxIds = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/taxIds",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadAccountAnalysis = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/accountAnalysis",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadTransactionAnalysis = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/transactionAnalysis",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadCustomerMiscellaneous = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/customerMiscellaneous",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadSupplierAnalysis = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/supplierAnalysis",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadCustomerAnalysis = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/customerAnalysis",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadClient = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/pdf/generatePdf/client",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
